<template lang="pug">
v-card
  v-card-title 
    v-btn(icon color="black" @click="$emit('back')")
      v-icon mdi-arrow-left
    span {{ title }}
  v-divider
  v-card-text
    v-row
      v-col.ptop-8.pbot-8(cols="6")
        fieldDatepicker(
          v-model="formData.date"
          label="Course Date"
          :min="currentDate"
          :hide-details="false"
          :error="formErrors.hasError('date')"
          :error-messages="formErrors.fields.date"
          @change="onFormChange()"
          @blur="onFormChange()"
        )

      v-col.ptop-8.pbot-8(cols="6")
        filter-autocomplete(
          v-model="formData.city"
          :getItems="getCourseLocation"
          item-text="name"
          item-value="ID"
          label="Course Location" 
          :error="formErrors.hasError('city')"
          :error-messages="formErrors.fields.city"
          @change="onFormChange"
        )
      v-col.ptop-8.pbot-8(cols="6")
        v-text-field(
          v-model="formData.maxStudents"
          type="number"
          min=0
          hide-details
          label="Max Students"
        )
      v-col.ptop-8.pbot-8(cols="6")
        v-text-field(
          v-model="formData.name"
          label='name'
          :error="formErrors.hasError('name')"
          :error-messages="formErrors.fields.name"
        )
      v-col.ptop-8.pbot-8(cols="6")
        v-text-field(
          v-model="formData.freePlaces"
          type="number"
          min=0
          max=8
          label="Free Places"
        )
      v-col.ptop-8.pbot-8(cols="6")
        v-switch(
          v-model="formData.is_provided"
          label="Is provided"
          color="green"
        )
      v-col.ptop-8(cols="12")
        v-radio-group.mt-0(
          v-model="formData.isVisibleOnLanding"
          :mandatory="false"
          :error="formErrors.hasError('isVisibleOnLanding')"
          :error-messages="formErrors.fields.isVisibleOnLanding"
        )
          v-radio(
            label='Visible on landing'
            :value="true"
          )
          v-radio(
            label='Invisible on landing'
            :value="false"
          )
    slot
  v-divider
  v-card-actions
    slot(name="actions" :formData="formData")
      v-spacer
      v-btn(outlined width="80").btn-common Cancel
      v-btn(color="primary" width="80").btn-common Add
</template>

<script>
import { convertToDefaultBackendFormat } from '@/util'
import { CourseEditable } from '../../../../models/courseModel'
import {mapActions, mapGetters} from 'vuex'

export default {
  props: {
    formErrors: Object,
    editData: Object,
    courseLocation: [String, Number],
    showing: Boolean,
    title: String,
  },
  data: () => ({
    formData: new CourseEditable(),
    currentDate: convertToDefaultBackendFormat(new Date(Date.now())),
  }),

  mounted() {
    if(this.courseLocation) {
      this.formData.city = parseInt(this.courseLocation);
      this.onFormChange();
    }
    // this.loadDefaultFormData()
  },

  computed: {
    ...mapGetters({
      citiesWithAdditionalInfo: 'crmCourseCities/itemsWithAdditionalInfo'
    })
  },

  methods: {
    ...mapActions({
      getCourseLocation: 'crmCourseCities/list'
    }),
    loadDefaultFormData() {
      Object.assign(this.formData, this.editData)
    },
    onFormChange() {
      const {city} = this.formData;
      let formObject = {
        date: this.formData.date,
        timeTo: '',
        timeFrom: '',
        location: '',
      };
      if(this.citiesWithAdditionalInfo) {
        const { city_exams } = this.citiesWithAdditionalInfo.find(({ID}) => city === ID);
        if(city_exams.length) {
          const [ exam ] = city_exams;
          formObject = {
            ...formObject,
            timeTo: exam.exam_time_to,
            timeFrom: exam.exam_time_from,
            location: exam.location,
          };
        }
      }
      this.$emit('update-form', formObject);
    }
  },

  watch: {
    showing: {
      handler: function(isShowing) {
        // if(isShowing) this.loadDefaultFormData()
      }
      
    }
  },

  components:{ 
    datepicker: () => import('@/app/admin/components/CrmDatepicker.vue'),
    timepicker: () => import('@/components/global/Timepicker.vue'),
    filterAutocomplete: () => import('@/components/global/FilterAutocomplete.vue'),
    fieldDatepicker: () => import('@/components/global/FieldDatepicker.vue')
  }
}
</script>


<style lang="scss" scoped>

  .ptop-8{
    padding-top: 8px;
  }

  .mt-0{
    margin-top: 0;
  }

  .pbot-8{
    padding-bottom: 8px;
  }

  ::v-deep .v-text-field{
    margin-top: 0;
    padding-top: 6px;
  }

</style>